module.exports = __webpack_public_path__ + "img/question-list-one.b0615931.png";